import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BaseComponent } from "BaseComponent";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DOMAIN_NAME, DEVELOPMENT_TYPE } from "Constants";
import LocaleStrings from "Languages";
import { checkTicketDaschoardStatus, fetchTickets } from "TicketAction";
import { fetchEventDetails } from "DashboardUserAction";

class Ticket extends BaseComponent {
  constructor(props) {
    super(props);
    this.ticket_url = React.createRef();

    this.state = {
      copied: false,
      copiedem: false,
      selectedTicket: null,
      header: false,
    };
  }

  componentDidMount() {
    this.props.checkTicketDaschoardStatus(this.props.session);
    this.props.fetchEventDetails(this.props.session);
    this.props.fetchTickets(this.props.session);
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  copyEmbed = () => {
    this.setState({ copiedem: true });

    setTimeout(() => {
      this.setState({ copiedem: false });
    }, 500);
  };

  onchange(e) {
    //console.log("selectedTicket", e.value);
    this.setState({ selectedTicket: e.value });
  }

  checkChange(e) {
    this.setState({ header: e.target.checked });
  }

  render() {
    let { eventDetails, ticketDashboard, ticketList } = this.props;
    let { selectedTicket, header } = this.state;

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";

    var ticketUrl = `https://${seocode}.${DOMAIN_NAME}/t/tickets`;
    ticketUrl += selectedTicket ? "/" + selectedTicket : "";
    ticketUrl += header ? "?header_footer=off" : "";

    let ticketArray = [];
    let obj = { label: "All", value: null };
    ticketArray.push(obj);
    if (ticketList && ticketList.resource && ticketList.resource.length > 0) {
      ticketList.resource.map((item, index) => {
        obj = { label: `${item.ticketname}`, value: item.id };
        ticketArray.push(obj);
      });
    }

    return (
      <div
        className="row ticket-dashboard scrollable-content"
        // style={{ height: deviceSize.height - 70 }}
      >
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          {ticketDashboard &&
          ticketDashboard.ticket &&
          ticketDashboard.setting ? (
            <div style={{ marginBottom: 20 }}>
              <div className="ticket-dashboard-ticket-created-page-main-div">
                <h4 className="heading-para">
                  {LocaleStrings.integration_ticket_link_address}
                </h4>
                <p className="promote-para">
                  {LocaleStrings.integration_ticket_link_address_text}
                </p>
                <div className="row">
                  <form>
                    <div className="col-md-12">
                      <Field
                        name="ticketid"
                        label={LocaleStrings.integration_ticket_select}
                        component={this.renderAutoComplete}
                        options={ticketArray}
                        labelKey="name"
                        valueKey="value"
                        isMulti={false}
                        onChange={(e) => this.onchange(e)}
                      />
                      <div className="integration-details-page">
                        <div className="pb-5">URL</div>
                        <div className="integration-details-page-box">
                          <div className="integration_ticket_url">
                            {ticketUrl}
                          </div>
                          <CopyToClipboard
                            text={ticketUrl}
                            onCopy={this.copyUrl}
                          >
                            <div
                              className={
                                this.state.copied
                                  ? "integration_url_copy_selected"
                                  : "integration_url_copy"
                              }
                            >
                              {this.state.copied ? (
                                <img src="../../style/images/integration/int_copy_copied.svg" />
                              ) : (
                                <img src="../../style/images/integration/int_copy.svg" />
                              )}
                            </div>
                          </CopyToClipboard>
                          <div className="integration_url_visit">
                            <a
                              href={ticketUrl}
                              target="blank"
                              className="integration_url_visit_hyper"
                              style={{ textDecoration: "none" }}
                            >
                              <span
                                aria-hidden="true"
                                className="custom-text1-secondary-medium"
                              >
                                {LocaleStrings.button_visit}
                              </span>
                              <img src="../../style/images/integration/visit.svg" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="ticket-dashboard-ticket-created-page-main-div pt-20">
                <h4 className="heading-para">
                  {LocaleStrings.integration_ticket_embed}
                </h4>
                <p className="promote-para">
                  {LocaleStrings.integration_ticket_embed_text}
                </p>
                <div className="row">
                  <div className="col-md-12">
                    <div className="integration-details-page">
                      <div className="pb-5">Embed Code</div>
                      <div className="integration-details-page-box">
                        <div
                          className="integration_ticket_url"
                          style={{ width: "92%" }}
                        >{`<iframe src="${ticketUrl}" style="margin: 15px; width: 100%; height:600px; border:1px solid black;" title="Event Ticket"></iframe>`}</div>
                        <CopyToClipboard
                          text={`<iframe src="${ticketUrl}" style="margin: 15px; width: 100%; height:600px; border:1px solid black;" title="Event Ticket"></iframe>`}
                          onCopy={this.copyEmbed}
                        >
                          <div
                            className={
                              this.state.copiedem
                                ? "integration_url_copy_selected"
                                : "integration_url_copy"
                            }
                          >
                            {this.state.copiedem ? (
                              <img src="../../style/images/integration/int_copy_copied.svg" />
                            ) : (
                              <img src="../../style/images/integration/int_copy.svg" />
                            )}
                          </div>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 pt-20">
                    <Field
                      name={"header_footer"}
                      label={LocaleStrings.integration_hide_header_footer}
                      type="checkbox"
                      component={this.renderFieldCheckbox}
                      onChange={(e) => this.checkChange(e)}
                    />
                    <div className="pl-30">
                      {LocaleStrings.integration_hide_header_footer_text}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  var initVals = {};
  initVals.ticketid = { label: "All", value: null };
  return {
    session: state.session,
    eventDetails: state.userEventDetails,
    deviceSize: state.deviceSize,
    ticketDashboard: state.ticketDashboard.data,
    ticketList: state.TicketList,
    initialValues: initVals,
  };
}

export default connect(mapStateToProps, {
  fetchEventDetails,
  checkTicketDaschoardStatus,
  fetchTickets,
})(
  reduxForm({
    form: "TicketEmbedForm",
    validate,
    enableReinitialize: true,
  })(Ticket)
);
